export default {
  GET_BANNER: "WebsiteSTNHD/TrangChu",
  GET_ASO_BANNER: "/UploadImage/list",
};
